import Rezagos from "./Rezagos";

export default Rezagos;
